 import React, {Component, Fragment} from 'react';
 import AppBar from '@material-ui/core/AppBar';
 import CssBaseline from '@material-ui/core/CssBaseline';
 import Toolbar from '@material-ui/core/Toolbar';
 import {Container, Card, CardContent, CardActions, Button} from '@material-ui/core'

 import { getWorkOrderById, closeWorkOrderObject} from '../../actions/WorkOrderAction'
 import {connect} from 'react-redux';

 //Actions
import {AddViewWorkOrder} from '../../actions/repairAction'

 //This page is use to view a WorkOrder an to close the workOrder from the link in the email

 class familyApp extends Component {
     constructor(props){
         super(props);

         this.state = {
             idRequest:this.props.match.params.idRequest  ? this.props.match.params.idRequest : '000',
             isClose: false,
             isViewDetails: this.props.isviewDetails? this.props.isviewDetails : true,
             action: this.props.action? this.props.action : 'details'
         }
     };


      componentDidMount(){

        if(this.state.idRequest && this.state.idRequest !== '000'){
            this.props.getWorkOrderById(this.state.idRequest);
        }

        
        const idRequest = this.state.idRequest? this.state.idRequest : undefined;
        const viewByObj ={
            userName:'From Email',
            pictureUrl:''
        }
        
        if(this.state.action && idRequest && viewByObj){
            this.props.AddViewWorkOrder(idRequest, viewByObj);
        }
     };

     closeRepair(item){       
        
        if(item.orderStatus !== 'completed'){           
            item.orderStatus = 'completed';
            item.repairDate = new Date();

            this.props.closeWorkOrderObject(item);
        }       
        
        

    };

     render(){
         if(this.state.action && this.state.action ==='close' &&  this.props.workOrderData && this.props.workOrderData._id){            
                 this.closeRepair(this.props.workOrderData)
         }

         const styleDiv ={
             textAlign:'center',
             color:'#959494',
             paddingTop:'8px',
             fontSize:'1.3em'
         }

         const styleDivTitle ={
             textAlign:'center',
             color:'#959494',
             fontSize:'1.7em'
         }

         const styleSpan ={
             fontWeight:'bold',
             fontSize:'1.1em'
         }

         const styleContainer={
             backgroundColor:'#454446'
         }

         const styleButtonCloseRequest={
             backgroundColor:'#009edd',
             color:'white',
             margin:'0px 5px'
         }

         const styleButtonCloseRequestDisbaled={
             backgroundColor:'#648dae',
             color:'white',
             margin:'0px 5px'
         }

         const styleDivButtons ={
             marginLeft:'auto'
         }

         let  isDisabled =  false;
         if (this.state.error){
                isDisabled = true
         } else{
             if(this.props.workOrderData && this.props.workOrderData.orderStatus === 'completed'){
                 isDisabled = true
             } else{
                 isDisabled = false
             }
         }
    
         return(
             <Fragment>
                 <div>
                     <CssBaseline />
                     <AppBar position="fixed" className="app-bar">
                         <Toolbar>
                             <div className="imgalignleft-engage">
                             <img
                                 src={`../../assets/images/Engage360-logo.png`}
                                 alt="logo"
                                 className="logo"
                             />
                                 &nbsp;<span className="Title-engage">Management</span>
                             </div>
                         </Toolbar>
                     </AppBar>
                 </div>
                 <div>
                 <Toolbar />
                 <Toolbar />                
                 <Container maxWidth="sm" >
                     <Card  variant="outlined">
                         <CardContent style={styleContainer}>
                             <div style={styleDivTitle}>
                                 <span style={styleSpan}>WORK ORDER</span>
                             </div>
                             {
                                 this.props.workOrderData ?
                                 <Fragment>
                                     <div style={styleDiv}>
                                         <span style={styleSpan}>Status: </span>{this.props.workOrderData.orderStatus? this.props.workOrderData.orderStatus: ''}
                                     </div>
                                     <div style={styleDiv}>
                                         <span  style={styleSpan} >Issue: </span>{(this.props.workOrderData.issue && this.props.workOrderData.issue.name) ? this.props.workOrderData.issue.name: ''}
                                     </div>
                                     <div style={styleDiv}>
                                         <span  style={styleSpan}>Item: </span>{(this.props.workOrderData.item && this.props.workOrderData.item.name) ? this.props.workOrderData.item.name: ''}
                                     </div>
                                     <div style={styleDiv}>
                                         <span  style={styleSpan}>Room: </span>{ (this.props.workOrderData.room && this.props.workOrderData.room.name) ? this.props.workOrderData.room.name: ''}
                                     </div>
                                 </Fragment>:
                                 ''
                             }
                           
                         </CardContent>
                     <CardActions  style={styleContainer}> 
                         <div style={styleDivButtons}>
                             <Button 
                                 style={isDisabled? styleButtonCloseRequestDisbaled :styleButtonCloseRequest} 
                                 disabled={isDisabled} 
                                 onClick={() => {if(this.props.workOrderData && this.props.workOrderData._id) this.closeRepair(this.props.workOrderData)}}>
                                 Close Work Order
                             </Button>                          
                         </div>                        
                     </CardActions>
                     </Card>
                 </Container>
                 </div>
             </Fragment>
           
            
         );             
     }
 };


 function mapStateToProps(state,dispatch) {
     const workOrderData = (state.workOrderReducer && state.workOrderReducer.workOrderData)? {...state.workOrderReducer.workOrderData} : undefined

     return {
         workOrderData: workOrderData
     }
 };

 export default connect(mapStateToProps,{getWorkOrderById, closeWorkOrderObject, AddViewWorkOrder})(familyApp)